<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template #activator="{ on, attrs }">
      <v-btn
        fab x-small rounded dark 
        class="ml-2" color="grey darken-1"
        v-bind="attrs" v-on="on"
      >
        <v-icon dark>mdi-tune</v-icon>
      </v-btn>
    </template>

    <v-form @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-title class="py-2">
          Filter Pros by
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-2 pb-0">
          <v-select
            v-if="userIsAdmin"
            outlined dense
            v-model="in_network"
            :items="partnerOptions"
            item-text="label"
            item-value="filter"
            label="Show Me"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="dialogVisible = false">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PartnerFilterDialog',

  data() {
    return {
      dialogVisible: false,

      partnerOptions: [
        { label: 'Enabled Pros', filter: 1 },
        { label: 'Blocked Pros', filter: 0 }
      ],

      in_network: 1,
    }
  },

  computed: {
    ...mapGetters('auth', ['userIsAdmin']),
    ...mapGetters('filters', ['partnerFilters']),
  },

  methods: {
    ...mapActions('filters', ['updatePartnerFilters']),
    ...mapActions('services', { loadAllServices: 'loadAll' } ),

    submitClick() {
      this.updatePartnerFilters( { 
        in_network: this.in_network,
      } )
      this.dialogVisible = false
    },

    onShow() {
      this.in_network = this.userIsAdmin ? this.partnerFilters.in_network :  1
    },
  },

  watch: {
    dialogVisible(visible) {
      if (visible) {
        this.onShow()
      }
    },
  },

  created() {
    this.loadAllServices()
  },
}
</script>